/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IntermediaryAssociatesViewModel
 */
export interface IntermediaryAssociatesViewModel {
    /**
     * 
     * @type {string}
     * @memberof IntermediaryAssociatesViewModel
     */
    institutionAgentCode: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryAssociatesViewModel
     */
    sanpayCode: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryAssociatesViewModel
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryAssociatesViewModel
     */
    surname: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryAssociatesViewModel
     */
    emailAddress: string;
}

/**
 * Check if a given object implements the IntermediaryAssociatesViewModel interface.
 */
export function instanceOfIntermediaryAssociatesViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "institutionAgentCode" in value;
    isInstance = isInstance && "sanpayCode" in value;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "surname" in value;
    isInstance = isInstance && "emailAddress" in value;

    return isInstance;
}

export function IntermediaryAssociatesViewModelFromJSON(json: any): IntermediaryAssociatesViewModel {
    return IntermediaryAssociatesViewModelFromJSONTyped(json, false);
}

export function IntermediaryAssociatesViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntermediaryAssociatesViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'institutionAgentCode': json['InstitutionAgentCode'],
        'sanpayCode': json['SanpayCode'],
        'firstName': json['FirstName'],
        'surname': json['Surname'],
        'emailAddress': json['EmailAddress'],
    };
}

export function IntermediaryAssociatesViewModelToJSON(value?: IntermediaryAssociatesViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'InstitutionAgentCode': value.institutionAgentCode,
        'SanpayCode': value.sanpayCode,
        'FirstName': value.firstName,
        'Surname': value.surname,
        'EmailAddress': value.emailAddress,
    };
}

